///-- THIS FILE IS GENERATED --///
export enum BackgroundSize {

    BG_AUTO = "pinata-bg-auto",

    BG_CONTAIN = "pinata-bg-contain",

    BG_COVER = "pinata-bg-cover",

}